import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routes } from '@app/app.routing';
// Componentes
import { AtendimentoListaComponent } from '@app/pages/agenda/atendimento/atendimento-lista/atendimento-lista.component';
import { TransferenciaAgendaComponent } from '@app/pages/agenda/transferencia-agenda/transferencia-agenda.component';
import { MeAviseListaComponent } from '@app/pages/agenda/me-avise/me-avise-lista.component';
import { TelefonicaListaComponent } from '@app/pages/agenda/telefonica/telefonica-lista/telefonica-lista.component';
import { TelefonicaFormComponent } from '@app/pages/agenda/telefonica/telefonica-form/telefonica-form.component';
import { MinhaAgendaFormComponent } from '@app/pages/agenda/minha-agenda/minha-agenda-form/minha-agenda-form.component';
import { MinhaAgendaListaComponent } from '@app/pages/agenda/minha-agenda/minha-agenda-lista/minha-agenda-lista.component';
import { LayoutComponent } from '@app/components/layout/layout.component';
import { AuthGuard } from '@app/guards/auth.guard';



export const agendaRoutes: Routes = [
  {
    path: '',
    children: [
      { path: 'atendimento', component: AtendimentoListaComponent, canActivate: [AuthGuard] },
      { path: 'atendimento/:id', component: AtendimentoListaComponent, canActivate: [AuthGuard] },

      { path: 'minha-agenda', component: MinhaAgendaListaComponent, canActivate: [AuthGuard] },
      { path: 'minha-agenda/novo', component: MinhaAgendaFormComponent, canActivate: [AuthGuard] },
      { path: 'minha-agenda/novo/:usuarioId', component: MinhaAgendaFormComponent, canActivate: [AuthGuard] },
      { path: 'minha-agenda/editar/:id', component: MinhaAgendaFormComponent, canActivate: [AuthGuard] },

      { path: 'transferencia-de-agenda', component: TransferenciaAgendaComponent, canActivate: [AuthGuard] },

      { path: 'meavise', component: MeAviseListaComponent, canActivate: [AuthGuard] },

      { path: 'telefonica', component: TelefonicaListaComponent, canActivate: [AuthGuard] },
      { path: 'telefonica/novo', component: TelefonicaFormComponent, canActivate: [AuthGuard] },
      { path: 'telefonica/editar/:id', component: TelefonicaFormComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(agendaRoutes)],
  exports: [RouterModule]
})

export class AgendaRoutingModule { }
